import app, { csl } from "@@assets/scripts/common";

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

app.exec();
